import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jobService } from "@/services/job.service";
import RegistrationModal from "@/pages/home/components/RegistrationModal";

const typeLabels: Record<string, string> = {
  'full-time': 'משרה מלאה', 'part-time': 'משרה חלקית', 'freelance': 'פרילנס',
};
const typeColors: Record<string, string> = {
  'full-time': '#D1FAE5', 'part-time': '#FEF9C3', 'freelance': '#EDE9FE',
};
const companyColors: Record<number, { bg: string; text: string }> = {
  1: { bg: "#EDE9FE", text: "#7C3AED" },
  2: { bg: "#D1FAE5", text: "#065F46" },
  3: { bg: "#FEF9C3", text: "#92400E" },
  4: { bg: "#FEE2E2", text: "#991B1B" },
};
const initials = (name: string) => {
  const words = name.trim().split(" ");
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

export default function AllJobsPage() {
  const [jobs, setJobs] = useState<any[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    jobService.list().then((all) => setJobs(all.filter((j: any) => j.status === "open"))).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen pb-8" style={{ background: "#FAF9F6", direction: "rtl" }} dir="rtl">
      <div className="sticky top-0 z-20 flex items-center justify-between px-4 py-3 border-b-2 border-gray-900 bg-white">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 rounded-xl border-2 border-gray-900 px-3 py-1.5 text-sm font-bold bg-white hover:bg-gray-50 cursor-pointer whitespace-nowrap">
          <i className="ri-arrow-right-line text-base" /> חזרה
        </button>
        <h1 className="text-lg font-black text-gray-900">כל המשרות</h1>
        <div className="w-16" />
      </div>

      <div className="px-4 pt-4">
        <p className="text-xs text-gray-500 mb-3">{jobs.length} משרות פתוחות</p>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {jobs.map((job, idx) => {
            const colors = companyColors[(idx % 4) + 1] ?? { bg: "#F3F4F6", text: "#374151" };
            return (
              <div key={job.id} className="bg-white rounded-2xl border-[2.5px] border-gray-900 p-4 flex flex-col gap-3">
                <div className="flex items-start gap-3">
                  <div className="w-12 h-12 flex-shrink-0 rounded-2xl border-2 border-gray-900 flex items-center justify-center font-black text-base select-none" style={{ background: colors.bg, color: colors.text }}>
                    {initials(job.company)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-sm font-black text-gray-900 leading-snug line-clamp-2">{job.title}</span>
                    <p className="text-xs text-gray-500 mt-1">{job.company}</p>
                  </div>
                  <span className="flex-shrink-0 text-xs font-black border-2 border-gray-900 rounded-full px-2 py-0.5 whitespace-nowrap" style={{ background: typeColors[job.type] || "#F3F4F6" }}>
                    {typeLabels[job.type] || job.type}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-gray-500 flex-wrap">
                  <span className="flex items-center gap-1"><i className="ri-map-pin-line text-gray-400"></i>{job.location}</span>
                  <span>|</span>
                  <span className="flex items-center gap-1"><i className="ri-group-line text-gray-400"></i>{job.applicants_count} מועמדים</span>
                </div>
                <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed">{job.description}</p>
                <div className="flex flex-wrap gap-1.5">
                  {(job.requirements || []).slice(0, 3).map((r: string) => (
                    <span key={r} className="text-xs px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-500">{r}</span>
                  ))}
                </div>
                <button onClick={() => { setSelectedJob(job); setModalOpen(true); }}
                  className="w-full bg-gray-900 text-white rounded-xl border-2 border-gray-900 py-2.5 text-sm font-black hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap">
                  הגש מועמדות
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <RegistrationModal isOpen={modalOpen} onClose={() => setModalOpen(false)}
        registerableType="Job"
        registerableId={selectedJob?.id}
      />
    </div>
  );
}
